import { useEffect, useState } from "react";
import { Droppable } from "react-beautiful-dnd";

const StrictModeDroppable = ({ children, ...props }) => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    setEnabled(true);
    return () => setEnabled(false);
  }, []);

  if (!enabled) {
    return null;
  }

  return (
    <Droppable {...props}>
      {(provided) => (
        <div ref={provided.innerRef} {...provided.droppableProps}>
          {children(provided)}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
};

export default StrictModeDroppable;
